export enum RoleType {
  INSTITUTION_ADMIN = "INSTITUTION_ADMIN",
}
